import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { hasAnonymization } from '../users';
import { ApplicationHistoryApiService } from './application-history-api.service';
import {
  applicationHistoryGet,
  applicationHistoryGetFailure,
  applicationHistoryGetSuccess
} from './application-history.actions';

@Injectable()
export class ApplicationHistoryEffects {
  getApplicationHistory$ = createEffect(() => this.actions$.pipe(
    ofType(applicationHistoryGet),
    withLatestFrom(this.store.select(hasAnonymization)),
    mergeMap(([{ associationId }, anonymised]) =>
      this.applicationHistoryApiService.get({
        id: associationId,
        params: { anonymised: anonymised ? 'true' : 'false' }
      })
        .pipe(
          map(({ content }) => applicationHistoryGetSuccess({
            associationId,
            history: content,
          })),
          catchError((error) => of(applicationHistoryGetFailure({ error }))),
        )
    ),
  ));

  constructor(
    private store: Store,
    private actions$: Actions,
    private applicationHistoryApiService: ApplicationHistoryApiService,
  ) {
  }
}
